/* const colors = {
  primary1: '#031F40',  // Dark blue
  primary2: '#ffb925',  // Green
  secondary1: '#C017A2',  // Fuchia
  secondary2: '#722282',  // Purple
  background: 'white',
  text: '#2a2a2a',
} */

import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  border: {
    radius: {
      base: '8px',
      xsm: '4px',
      sm: '8px',
      md: '12px',
      lg: '18px',
    }
  },
  spacing: {
    largeLateral: '10%',
    smallLateral: '3%',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  typography: {
    fontSize: {
      base: '16px',
      s1: '3rem',
      s2: '2.3rem',
      s3: '1.9rem',
      s4: '1.4rem',
      s5: '1rem',
      s6: '0.7rem', 
    },
    fontWeight: {
      regular: 300,
      medium: 400,
      bold: 700,
    },
  },
  colors: {
    primary1: '#4A9462',  // Green
    primary2: '#0B3465',  //'#031F40',  Dark blue
    secondary1: '#C017A2',  // Fuchia
    secondary2: '#722282',  // Purple
    light: 'white',
    dark: '#2a2a2a',
    text: '#5a5a5a',
    background: '#F5F6FA',
    background2: '#f7f7f7',
    warn: 'tomato',
    border: 'lightgray',
    error: 'tomato',
  },
  sizing: {
    createFormsWidt: {
      max: '700px',
      min: '500px',
    }
  },
  shadow: {
    s1: '0 5px 5px rgba(0, 0, 0, 0.2)',
    s2: '0 4px 12px rgba(0, 0, 0, 0.08)',
  }
};
